import * as React from "react";
import { Redirect } from "react-router";
import axios, { AxiosRequestConfig } from 'axios';

export let baseApiUri = `${window.location.origin}/`;

const withAuthToken = () => ({
    headers: {
       // 'Authorization': sessionStorage.getItem("gdscp_userToken") // gdscp_userToken is now stored in http only cookie
    }
});

const withBufferAuthToken = (): AxiosRequestConfig => ({
    headers: {
        // 'Authorization': sessionStorage.getItem("gdscp_userToken") // gdscp_userToken is now stored in http only cookie
    },
    responseType: 'arraybuffer'
});

const apiPath = "api/";
const loginPath = apiPath + "Login/";
const tokenPath = apiPath + "Token/";
const managementPath = apiPath + "Management/";
const logoutPath = apiPath + "Logout/";
const companyPath = apiPath + "Company/";
const userPath = apiPath + "User/";
const applicationPath = apiPath + "Application/";
const reportPath = apiPath + "Report/";
const consolePath = `${apiPath}Console/`;
const dashboardPath = `${apiPath}Dashboard/`;
const roleManagementPath = apiPath + "RoleManagement/";
const applicationShortcutPath = `${apiPath}ApplicationShortcut/`;
const announcementPath = `${apiPath}Announcement/`;
const chatbotPath = `${apiPath}Chatbot/`;

export const loginUrl = loginPath;
export const validateTokenUrl = tokenPath + 'validation';
export const logoutUrl = logoutPath;
export const refreshSessionUrl = tokenPath + 'refresh-session';



export const getUserListUrl = userPath + "get-user-list";
export const getUserListUrlRoot = userPath + "get-user-list-root";
export const createUserUrl = userPath + "create-user";
export const updateUserUrl = userPath + "update-user";
export const deleteUserUrl = userPath + "delete-user";
export const disableUserMasterUrl = userPath + "disable-user-master";
export const disableUserUrl = userPath + "disable-user";
export const updateUserMasterUrl = userPath + "update-user-master";
export const getUserPortalRolesUrl = userPath + "get-portal-roles";
export const getUsersByRoleNameUrl = userPath + "get-users-by-role-name";
export const getRealmUserCountUrl = userPath + "get-realm-user-count";
export const getInternalIdpsUrl = userPath + "get-internal-idps";
export const getAccessibleAppsWithRolesUrl = userPath + "get-accessible-apps-with-roles";
export const updateUserAppRolesUrl = userPath + "update-app-roles";
export const checkSpecialRolesExistUrl = userPath + "check-special-roles-exist";
//export const getUserPortalRolesUrl = userPath + "get-user-client-roles";
export const currentCompanyUrl = applicationPath + "user-company";

export const idpUrl = managementPath + "Idps";
export const updateIdpUrl = managementPath + "update-idp";
export const createCompanyUrl = managementPath + "create-company";
export const deleteCompanyUrl = managementPath + "delete-company";
export const idpClientsUrl = managementPath + "IdpClients";
export const portalClientIDUrl = managementPath+"portalClientID"
export const idpClientEditUrl = managementPath + "IdpClients/update-client";
export const idpMapperUrl = idpClientsUrl + "/mappers";
export const createIdpMapperUrl = idpClientsUrl + "/create-mapper";
export const updateIdpMapperUrl = idpClientsUrl + "/update-mapper";
export const currentIdpClientsManagementUrl = managementPath + "IdpCurrentClients";
export const getCompanyUrlListUrl = managementPath + "get-company-urls";
export const addCompanyUrlConfigUrl = managementPath + "add-company-url";
export const updateCompanyUrlConfigUrl = managementPath + "update-company-url";
export const removeCompanyUrlConfigUrl = managementPath + "delete-company-url";

export const idpRoleUrl = roleManagementPath + "RoleIdps";
export const roleMapperUrl = roleManagementPath + "get-roles";
export const createRoleUrl = roleManagementPath + "create-role";
export const editRoleUrl = roleManagementPath + "edit-role";
export const deleteRoleUrl = roleManagementPath + "delete-role";
export const currentIdpClientsUrl = roleManagementPath + "clients";
export const createClientUrl = roleManagementPath + "create-client";

const applicationPermissionsUrl = applicationPath + "permissions";
const userProfileUrl = applicationPath + "user-profile";
const generateQuickSightEmbedUrlUrl = reportPath + "quicksight/embed-url";
const getUserDashboardsUrl = `${consolePath}user-dashboards`;
const quickSightDashboardEmbedUrl = `${consolePath}quicksight-dashboard`;

const powerBIDashboardEmbedUrl = `${consolePath}powerbi-dashboard`;
const getNarrativeReportUrl = `${dashboardPath}get-narrative-report`;
const getDashboardsUrl = `${dashboardPath}all`;
const getDashboardUrl = `${dashboardPath}`;
const createDashboardUrl = `${dashboardPath}`;
const updateDashboardUrl = `${dashboardPath}`;
const deleteDashboardUrl = `${dashboardPath}`;
const addUserDashboardsUrl = `${dashboardPath}user-dashboard/`;
const deleteUserDashboardUrl = `${dashboardPath}user-dashboard/`;
const getUserApplicationShortcutsUrl = `${applicationShortcutPath}user`;
const addUpdateUserApplicationShortcutsUrl = `${applicationShortcutPath}user/add_update`;
const getAnnouncementUrl = `${announcementPath}get-announcement`;
const getAnnouncementListUrl = `${announcementPath}get-announcement-list/`;
const addAnnouncementUrl = `${announcementPath}add/`;
const updateAnnouncementUrl = `${announcementPath}update/`;
const removeAnnouncementtUrl = `${announcementPath}remove`;

const chatbotMessageUrl = `${chatbotPath}message`;
const chatbotWebsocketUrl = `${chatbotPath}ws`;

/**
 * Create instance of AXIOS
 * @type {AxiosInstance}
 */
const service = axios.create({
    baseURL: baseApiUri
});

requestInterceptor();
responseInterceptor();

// INTERCEPTOR METHODS
export function requestInterceptor() {
    service.interceptors.request.use(function (request: any) {
        return request;
    }, function (error: any) {
        return Promise.reject(error);
    });
}

function getCookie(name: string): string | undefined {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const part = parts.pop();
        if (part) {
            return part.split(';').shift();
        }
    }
    return undefined;
}

export function responseInterceptor() {
    service.interceptors.response.use(function (response: any) {
        return response;
    }, function (error: any) {
        console.log(error);
        if (error.response === undefined) {
            // return Promise.reject(error);
            sessionStorage.clear();
            return <Redirect exact to="/error" />;
        }
        if (error.response.status === 401) {
            var gdscp_userAuthenticatedCookie = getCookie("gdscp_userAuthenticated");
            console.log('401');
            if (gdscp_userAuthenticatedCookie == null) {
                document.location.href = loginUrl;
            }
        }
        if (error.response.status === 417) {
            console.log('417');
        }
        if (error.response.status === 456) { // custom response sent by Portal server when JWT is blacklisted after a backchannel logout
            console.log('Session blacklisetd');
            sessionStorage.clear();
            document.location.href = "/LoggedOut";
        }
        return Promise.reject(error);
    });
}

export function logout() {
    return service.get(logoutUrl, withAuthToken()).then((response) => response.data);
}

export function validateToken() {
    return service.get(validateTokenUrl, withAuthToken()).then((response) => response.data);
}

export function getApplicationPermissions() {
    
    return service.get(applicationPermissionsUrl, withAuthToken())
            .then((response) => response.data)
            .catch((e) => { return e; });
 
}

export function launch(url: string) {
    return service.get(url, withAuthToken());
}

export function getUserProfile() {
    return service.get(userProfileUrl, withAuthToken()).then((response) => response.data);
}

export function generateQuickSightEmbedReportUrl() {
    return service.get(generateQuickSightEmbedUrlUrl, withAuthToken());
}

export async function getUserList(company: string) {
    return await service.get(getUserListUrl, {
        headers: {

        },
        params: { realm: company }
    })
        .then(response => response.data);
}

export async function searchUserList(company: string, search: string) {
    return await service.get(getUserListUrl, {
        params: { realm: company, search, brief: true }
    })
        .then(response => response.data);
}

export function createCompany(obj: any) {
    return service
        .post(createCompanyUrl, JSON.stringify(obj), {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response.data);
}

export function deleteCompany(realm: string, idpAlias: string) {
    return service.post(`${deleteCompanyUrl}/${realm}/${idpAlias}`, null, {
        headers: {
            
            "Content-Type": "application/json",
            'Accept': 'application/json'
        }
    })
        .then(response => response);
}



export function createUser(obj: any) {
    return service
        .post(createUserUrl, JSON.stringify(obj), {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response.data);
}



export function updateUser(obj: any) {
    return service
        .post(updateUserUrl, JSON.stringify(obj), {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function deleteUser(obj: any) {
    return service
        .post(deleteUserUrl, JSON.stringify(obj), {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}
export function disableUser(obj: any) {
    return service
        .post(disableUserUrl, JSON.stringify(obj), {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function disableUserMaster(obj: any) {
    return service
        .post(disableUserMasterUrl, JSON.stringify(obj), {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function updateUserMaster(obj: any) {
    return service
        .post(updateUserMasterUrl, JSON.stringify(obj), {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export async function getUserPortalRoles(company: string, userId: string) {
    return await service
        .get(getUserPortalRolesUrl, {
            headers: {
                
            },
            params: {
                userId: userId,
                realm: company
            }
        })
        .then(response => response.data);
}

export async function getRealmUserCount(realm: string) {
    return await service.get(`${getRealmUserCountUrl}/${realm}`, withAuthToken()).then(response => response.data);
}

export async function getInternalIdps(pCompanyFilter: string = "") {
    return await service
        .get(getInternalIdpsUrl, {
            headers: {
                
            },
            params: {
                companyFilter: pCompanyFilter
            }
        })
        .then(response => response.data);
}

export function getIdentityProviders() {
    return service.get(idpUrl, withAuthToken()).then(response => response.data);
}

export function getAccessibleAppsWithRoles(idpAlias: string, userId: string) {
    return service
        .get(getAccessibleAppsWithRolesUrl, {
            headers: {
                
            },
            params: { company: idpAlias, userId: userId }
        })
        .then(response => response.data);
}

export function getUsersByRoleName(realm: string, roleName: string) {
    return service
        .get(getUsersByRoleNameUrl, {
            headers: {
                
            },
            params: {
                realm: realm,
                roleName: roleName
            }
        })
        .then(response => response.data);
}
export function updateUserAppRoles(obj: any) {
    return service
        .post(updateUserAppRolesUrl, JSON.stringify(obj), {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function checkSpecialRolesExist() {
    return service.get(checkSpecialRolesExistUrl, withAuthToken()).then((response) => response.data);
}

export function getUserDashboards() {
    return service.get(getUserDashboardsUrl, withAuthToken());
}

export function getQuickSightDashboardEmbedUrl(key: string) {
    return service.get(`${quickSightDashboardEmbedUrl}/${key}`, withAuthToken());
}
export function getPowerBIDashboardEmbedUrl(key: string) {
    return service.get(`${powerBIDashboardEmbedUrl}/${key}`, withAuthToken());
}

export function getDashboards(pRealm:string) {
    return service.get(`${getDashboardsUrl}/${pRealm}`, withAuthToken());
}

export function getDashboard(key: string) {
    return service.get(`${getDashboardUrl}${key}`, withAuthToken());
}

export function createDashboard(dashboard: any, company: string) {
    return service.put(createDashboardUrl, { ...dashboard,"realm":company }, withAuthToken());
}

export function updateDashboard(dashboard: any) {
    return service.post(updateDashboardUrl, dashboard, withAuthToken());
}

export function deleteDashboard(key: string) {
    return service.delete(`${deleteDashboardUrl}${key}`, withAuthToken());
}

export function addUserDashboards(key: string, emails: string[]) {
    return service.put(`${addUserDashboardsUrl}${key}`, emails, withAuthToken());
}

export function deleteUserDashboard(key: string, userDashboardId: number) {
    return service.delete(`${deleteUserDashboardUrl}${key}/${userDashboardId}`, withAuthToken());
}

export function updateIdp(obj: any) {
    return service
        .put(updateIdpUrl, obj, {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}
export function getPortalClientID() {
    return service.get(portalClientIDUrl, withAuthToken()).then(response => response.data);
}
export function getIdpClients() {
    return service.get(idpClientsUrl, withAuthToken()).then(response => response.data);
}

export function getIdpMappers(idpName: any) {
    return service.get(idpMapperUrl + "/" + idpName, withAuthToken()).then(response => response.data);
}

export function createIdpMappers(obj: any) {
    return service
        .post(createIdpMapperUrl, obj, {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function updateIdpMapper(obj: any) {
    return service
        .put(updateIdpMapperUrl, obj, {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export async function getClientRoles(clientID: any, realmName: any) {
    var rs = await service.get(roleMapperUrl + "/" + clientID + "/" + realmName, withAuthToken()).then(response => response.data);
    return rs;
}

export function createRole(obj: any, realmName: any) {
    return service
        .post(createRoleUrl + "/" + realmName, obj, {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function getCurrentIdpClientsManagement(realmName: any) {
    return service.get(currentIdpClientsManagementUrl + "/" + realmName, withAuthToken()).then(response => response.data);
}

export function getCurrentIdpClients(realmName: any, userRealm: any, displayInConsoleNOTRequired: boolean = false) {
    return service.get(currentIdpClientsUrl + "/" + realmName + "/" + userRealm + (displayInConsoleNOTRequired ?"?displayInConsoleNOTRequired=true":""), withAuthToken()).then(response => response.data);
}

export function createClient(obj: any, realmName: any) {
    return service
        .post(createClientUrl + "/" + realmName, obj, {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function editClient(obj: any, realmName: any, id: any) {
    return service
        .put(idpClientEditUrl + "/" + realmName + "/" + id, obj, {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function editRole(obj: any, realmName: any, clientId: any, roleName: any) {
    return service
        .put(editRoleUrl + "/" + realmName + "/" + clientId + "/" + roleName, obj, {
            headers: {
                
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function deleteRole(realmName: any, clientId: any, roleName: any) {
    return service.delete(deleteRoleUrl + "/" + realmName + "/" + clientId + "/" + roleName, withAuthToken()).then(response => response.data);
}

export function getCurrentCompany() {
    return service.get(currentCompanyUrl, withAuthToken()).then(response => response.data);
}

export function getRoleIdentityProviders(realmName: any) {
    return service.get(idpRoleUrl + "/" + realmName, withAuthToken()).then(response => response.data);
}

export function exportToFileInGroup(key: string, format: string) {
    return service.get(`${powerBIDashboardEmbedUrl}/export-to-file/${key}/${format}`, withAuthToken());
}

export function getExportToFileStatusInGroup(key: string, exportId: string) {
    return service.get(`${powerBIDashboardEmbedUrl}/get-export-status/${key}/${exportId}`, withAuthToken());
}

export function getFileOfExportToFileInGroup(key: string, format: string, exportId: string) {
    return service.get(`${powerBIDashboardEmbedUrl}/get-file-of-export/${key}/${format}/${exportId}`, withBufferAuthToken());
}

export function getUserApplicationShortcuts() {
    return service.get(getUserApplicationShortcutsUrl, withAuthToken());
}

export function addUpdateUserApplicationShortcuts(email: string, shortcuts: string, urlShortcuts: string[]) {
    return service.put(`${addUpdateUserApplicationShortcutsUrl}/${email}`, JSON.stringify({ shortcutIds: shortcuts, urlShortcutIds: urlShortcuts }), {
        headers: {
            
            "Content-Type": "application/json",
            'Accept': 'application/json'
        }
    });
}

export function getAnnouncement(id: string) {
    return service.get(`${getAnnouncementUrl}/${id}`, withAuthToken());
}
export function getAnnouncementList() {
    return service.get(getAnnouncementListUrl, withAuthToken());
}

export function addAnnouncement(announcementPayload: any) {
    return service.put(addAnnouncementUrl, announcementPayload, {
        headers: {
            
            "Content-Type": "application/json",
            'Accept': 'application/json'
        }
    });
}

export function updateAnnouncement(announcementPayload: any) {
    return service.put(updateAnnouncementUrl, announcementPayload, {
        headers: {
            
            "Content-Type": "application/json",
            'Accept': 'application/json'
        }
    });
}

export function removeAnnouncement(id: number) {
    return service.delete(`${removeAnnouncementtUrl}/${id}`, withAuthToken());
}

export function getCompanyUrlList(realm: string) {
    return service.get(`${getCompanyUrlListUrl}/${realm}`, withAuthToken());
}

export function getCompanyUrlListByType(realm: string, urlType: string) {
    return service.get(`${getCompanyUrlListUrl}/${realm}/${urlType}`, withAuthToken());
}

export function addCompanyUrl(companyUrlPayload: any) {
    return service.put(addCompanyUrlConfigUrl, companyUrlPayload, {
        headers: {
            'Authorization': sessionStorage.getItem("gdscp_userToken"),
            "Content-Type": "application/json",
            'Accept': 'application/json'
        }
    });
}

export function updateCompanyUrl(companyUrlPayload: any) {
    return service.put(updateCompanyUrlConfigUrl, companyUrlPayload, {
        headers: {
            'Authorization': sessionStorage.getItem("gdscp_userToken"),
            "Content-Type": "application/json",
            'Accept': 'application/json'
        }
    });
}

export function removeCompanyUrl(id: number) {
    return service.delete(`${removeCompanyUrlConfigUrl}/${id}`, withAuthToken());
}

export function refreshSession() {
    return service.get(refreshSessionUrl, withAuthToken());
}

export function sendChatbotMessage(obj: any) {
    return service
        .post(chatbotMessageUrl, obj, {
            headers: {
                "Content-Type": "application/json",
                'Accept': 'application/json'
            }
        })
        .then(response => response);
}

export function createChatbotPortalWebSocket() {
    const proto = window.location.protocol === "https:" ? "wss" : "ws";
    return new WebSocket(`${proto}://${window.location.host}/${chatbotWebsocketUrl}`);
}

export function getNarrativeReport(reportId: string) {
    return service.get(`${getNarrativeReportUrl}/${reportId}`, withBufferAuthToken());
}